{
  "version": 1,
  "asset_id": "6502af00-0ed9-4ae6-b6c3-4c1f81e14f0c",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/6502af00-0ed9-4ae6-b6c3-4c1f81e14f0c/sylwia-bigfive.jpg",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/6502af00-0ed9-4ae6-b6c3-4c1f81e14f0c/sylwia-bigfive.jpg",
  "original_filename": "sylwia-bigfive.jpg",
  "size": 108543,
  "content_type": "image/jpeg",
  "created_at": "2026-08-22T08:24:30Z"
}
